// Note, this component is used in multiple places.
// Probably not best to have static CSS since it may
// vary based on context this component is displayed in.
import { useTranslation } from 'react-i18next';

const Days = (props) => {
  const { t } = useTranslation();
  if (props.start === props.end) {
    return (
      <span className="Days">
        {t('day')}: {props.start}
      </span >
    );
  }
  return (
    <span className="Days">
      {t('days_label')}: {props.start} - {props.end}
    </span>
  );
}
export default Days;
